import {
  getBufferLayer,
  getHighlightLayer,
  getMarkerLayer,
} from '@/map/mapStore';
import { clearRenderHistory } from './render';
import type { Tool } from './types';

type Bucket = 'highlights' | 'markers' | 'buffers' | 'all';

type Input = { bucket?: Bucket };

export const renderClear: Tool<Input> = {
  name: 'render_clear',
  description:
    'Remove rendered graphics. Default ("all") wipes highlights, markers, and buffers. Pass a single bucket to leave the others alone.',
  input_schema: {
    type: 'object',
    properties: {
      bucket: { enum: ['highlights', 'markers', 'buffers', 'all'] },
    },
    additionalProperties: false,
  },
  execute: ({ bucket = 'all' } = {}) => {
    const cleared: string[] = [];
    if (bucket === 'highlights' || bucket === 'all') {
      getHighlightLayer()?.removeAll();
      clearRenderHistory('highlights');
      cleared.push('highlights');
    }
    if (bucket === 'markers' || bucket === 'all') {
      getMarkerLayer()?.removeAll();
      clearRenderHistory('markers');
      cleared.push('markers');
    }
    if (bucket === 'buffers' || bucket === 'all') {
      getBufferLayer()?.removeAll();
      clearRenderHistory('buffers');
      cleared.push('buffers');
    }
    return { cleared };
  },
};
